/* eslint-disable @typescript-eslint/no-explicit-any */
import { filterActiveNorwegianVatRates } from '@/app/Vat';

export const initState = {};

export default {
  Query: {
    activeNorwegianVatRates: (
      root: any,
      { date }: { date: string },
    ) => {
      return filterActiveNorwegianVatRates(
        root.allNorwegianVatRates,
        date,
      );
    },
    activeNorwegianVatRatesMap: (
      root: any,
      { date }: { date: string },
    ) => {
      const vatRates = filterActiveNorwegianVatRates(
        root.allNorwegianVatRates,
        date,
      );

      return new Map(vatRates.map(v => [ v.symbol, v ]));
    },
  },
  Mutation: {

  },
};
